import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { FormControl } from '@angular/forms';

import { ApiValidationField } from './api-validation-field.model';

@Injectable()
export class ApiValidationService {

  private validationFields: { [apiFieldName: string]: ApiValidationField } = {};

  constructor() { }

  public registerField(apiFieldName: string, formControl: FormControl) {
    if (this.validationFields.hasOwnProperty(apiFieldName)) {
      return;
    }

    this.validationFields[apiFieldName] = new ApiValidationField(formControl);
  }

  public setResponse(apiResponse: Response): void {
    const responseChildren: any = apiResponse.json()['children'];

    if (
      null === responseChildren ||
      'object' !== typeof responseChildren
    ) {
      return;
    }

    for (const apiFieldName in this.validationFields) {
      if (
        !this.validationFields.hasOwnProperty(apiFieldName) ||
        !responseChildren.hasOwnProperty(apiFieldName)
      ) {
        continue;
      }

      this.validationFields[apiFieldName].setError(
        this.parseError(responseChildren[apiFieldName])
      );
    }
  }

  public hasFieldError(fieldName: string): boolean {
    return (
        this.validationFields.hasOwnProperty(fieldName) &&
        this.validationFields[fieldName].hasError()
      );
  }

  public getFieldError(fieldName: string): string {
    if (!this.hasFieldError(fieldName)) {
      return '';
    }

    return this.validationFields[fieldName].getError();
  }

  private parseError(errorData: any): string {
    if (
      !errorData.hasOwnProperty('errors') ||
      !Array.isArray(errorData['errors']) ||
      0 === errorData['errors'].length
    ) {
      return '';
    }

    return errorData['errors'][0];
  }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/api-validation/api-validation.service.ts